module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/205/assets/images/d55139b0100732da65d78f8ad9eb7718.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_pass_hide_active.svg
// module id = nPBh
// module chunks = 1